/**
 * TaskTemplate model translations
 *
 * Translation keys follow the pattern: models.task_template.{category}.{key}
 * Categories: fields, tabs, blocks, badges, filters, options
 */
export default {
  en: {
    singular: "Task Template",
    plural: "Task Templates",

    tabs: {
      general: "General",
      usage: "Usage",
    },

    blocks: {
      identity: "Identity",
      schedule: "Schedule Defaults",
      addInfos: "Instructions",
      attachments: "Attachments",
    },

    fields: {
      title: "Title",
      description: "Description",
      is_active: "Active",
      sort_order: "Sort Order",
      default_frequency: "Default Frequency",
      default_duration_minutes: "Default Duration",
      usage_count: "Usage Count",
      created_at: "Created At",
      updated_at: "Updated At",
      app_data: {
        addInfos: "Instructions",
      },
    },

    badges: {
      weekly: "Weekly",
      biweekly: "Biweekly",
      triweekly: "Triweekly",
      monthly: "Monthly",
      bimonthly: "Bimonthly",
      quarterly: "Quarterly",
      custom: "Custom",
      true: "Yes",
      false: "No",
    },

    filters: {
      is_active: "Status",
      default_frequency: "Frequency",
    },

    options: {
      default_frequency: {
        weekly: "Every Week",
        biweekly: "Every Two Weeks",
        triweekly: "Every Three Weeks",
        monthly: "Monthly",
        bimonthly: "Every Two Months",
        quarterly: "Every Three Months",
        custom: "Custom",
      },
    },
  },

  fr: {
    singular: "Modèle de tâche",
    plural: "Modèles de tâches",

    tabs: {
      general: "Général",
      usage: "Utilisation",
    },

    blocks: {
      identity: "Identité",
      schedule: "Paramètres d'horaire",
      addInfos: "Instructions",
      attachments: "Pièces jointes",
    },

    fields: {
      title: "Titre",
      description: "Description",
      is_active: "Actif",
      sort_order: "Ordre",
      default_frequency: "Fréquence par défaut",
      default_duration_minutes: "Durée par défaut",
      usage_count: "Nombre d'utilisations",
      created_at: "Créé le",
      updated_at: "Modifié le",
      app_data: {
        addInfos: "Instructions",
      },
    },

    badges: {
      weekly: "Hebdomadaire",
      biweekly: "Aux 2 semaines",
      triweekly: "Aux 3 semaines",
      monthly: "Mensuel",
      bimonthly: "Aux 2 mois",
      quarterly: "Aux 3 mois",
      custom: "Personnalisé",
      true: "Oui",
      false: "Non",
    },

    filters: {
      is_active: "Statut",
      default_frequency: "Fréquence",
    },

    options: {
      default_frequency: {
        weekly: "Toutes les semaines",
        biweekly: "Aux deux semaines",
        triweekly: "Aux trois semaines",
        monthly: "Mensuel",
        bimonthly: "Aux deux mois",
        quarterly: "Aux trois mois",
        custom: "Personnalisé",
      },
    },
  },
};
